import {bindTypesToActions} from '@src/utils/redux_utils';


const types={
    //sage actions:
    GetData:'USER_GETDATA',
    LoginUser:'USER_LOGIN',
    SignupUser:'USER_SIGNUP',
    RefreshUser:'USER_REFRESH_USER',
    UpdateLanguage: 'USER_UPDATE_LANGUAGE',
    Email:'USER_EMAIL',
    SubscriberId:'USER_SUBSCRIBER_ID',
   
   // reducer actions
    DataSuccess:'USER_DATA_SUCCESS',
    EmailUpdate:'USER_EMAIL_UPDATE',
    ResetData:'USER_DATA_RESET',
    LogoutUser: 'USER_LOG_OUT',
    LogoutUserPassword: 'USER_LOG_OUT_PASSWORD',
    IsAuthenticated:'USER_IS_AUTHENTICATED',
    ToggleVerification:'USER_TOGGLE_VERIFICATION',
    selectLanguage:'USER_LANGUAGE_SELECTION',
    //Set if the  game is active
    SetGameStatus:"SET_STATUS",
    SocialLogin:'USER_SOCIAL_LOGIN',

}

const UserActions=bindTypesToActions(types);

const getLangMeta = ( langList = [], code = 'eng' ) => langList.find( item => item.code === code ) ?? {code : 'eng',lang : 'English',shortcode : 'en'} ;

const initialState={
    email:null,
    subscriberId:null,
    data:null,

    //flags:
    isAuthenticated:false,
    isVerified:false,
    language:"eng",
    langmeta: {}
}

const UserReducer=(state=initialState,{type,payload})=>{
    switch(type){
        case types.DataSuccess:
            const userData = {
                ...state,
                email: payload.email,
                subscriberId: payload.subscriberid,
                language: payload.preferredlanguage || 'eng',
                languageList: payload.languageList ?? [],
                langmeta: getLangMeta( payload.languageList, payload.preferredlanguage ),
                data: { ...payload }
            }
            return userData;
        case types.EmailUpdate:
            const { email } = payload;
            return { ...state, email }
        case types.ResetData:
        case 'LOG_OUT_ALL':
            return initialState;
        case types.ToggleVerification:
            const isVerified =payload?.isVerified;
            return {
                ...state,
                isVerified
            }
        case types.selectLanguage:
            const { language } = payload;
            const langmeta = getLangMeta( state.languageList, language );
            return {
                    ...state,
                    language,
                    langmeta   
                }         
        case types.IsAuthenticated:
            const isAuthenticated = payload?.isAuthenticated ?? false ;
            return {
                ...state,
                isAuthenticated
            }
        case types.SetGameStatus:
            const { isgamePlaying } = payload ;
                // if( !isgamePlaying )return state ;
            return {
                ...state,
                isgamePlaying: isgamePlaying
                }
        case types.SocialLogin:
            const { issocialLogin } = payload ;
                        // if( !isgamePlaying )return state ;
            return {
                ...state,
                SocialLogin: issocialLogin
                }
            
        default: return state;    
    }
}

export {
    types as UserTypes,
    UserReducer,
    UserActions
}